import React from 'react';
import SchoolViewTableSkeleton from '../school-views/SchoolViewTableSkeleton';

const SUMMARY_ITEMS = 5;
const QUEUE_CHIPS = 2;
/** Dropdowns per filter section: location, status, management. */
const FILTER_SECTIONS = [2, 4, 2];
const STAGE_TABS = 5;

const Bone = ({ className }: { className: string }) => <div className={`skeleton ${className}`} />;

/** Mirrors the control page: the summary strip, the queue line, one card with the search, the titled filter sections and the stage tabs, then the table. */
const SchoolControlSkeleton: React.FC = () => (
  <div>
    <div className="card px-4 py-3 mb-3 flex flex-wrap gap-x-8 gap-y-2">
      {Array.from({ length: SUMMARY_ITEMS }).map((_, i) => <Bone key={i} className="h-6 w-36" />)}
    </div>
    <div className="flex gap-2 mb-3">
      {Array.from({ length: QUEUE_CHIPS }).map((_, i) => <Bone key={i} className="h-7 w-44 rounded-md" />)}
    </div>
    <div className="card mb-3">
      <div className="px-3 py-2.5 grid gap-2.5">
        <Bone className="h-8 w-full sm:w-96 rounded-md" />
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {FILTER_SECTIONS.map((count, i) => (
            <div key={i} className="flex items-center gap-2">
              <Bone className="h-3 w-16" />
              {Array.from({ length: count }).map((_, j) => <Bone key={j} className="h-8 w-24 rounded-md" />)}
            </div>
          ))}
        </div>
      </div>
      <div className="flex gap-6 border-t border-border px-3 py-2.5">
        {Array.from({ length: STAGE_TABS }).map((_, i) => <Bone key={i} className="h-4 w-24" />)}
      </div>
    </div>
    <SchoolViewTableSkeleton cols={6} twoLineCols={[4]} />
  </div>
);

export default SchoolControlSkeleton;
